import { router } from "expo-router"
import { useUpdateMarketData } from "@/queries/markettrends"
import MarketTrendsLocationSearch from "@/screens/MarketTrendsLocationSearch"

export default function RegionSearchScreen() {
  const { mutate: updateMarketData } = useUpdateMarketData()

  const onRegionSelect = (region: string | null) => {
    if (!region) {
      console.error("No Region Present")
      return
    }

    let city: string | null = null
    let state: string | null = null
    let zipcode: string | null = null

    // Check if the region is a number (zipcode)
    if (/^\d+$/.test(region)) {
      zipcode = region
    } else {
      const parts = region.split(",")
      if (parts.length === 1) {
        // No comma present, treat as city
        city = parts[0].trim()
      } else if (parts.length === 2) {
        // Format "city, state"
        city = parts[0].trim()
        state = parts[1].trim()
      }
    }

    updateMarketData({ city, state, zipcode })

    // Navigate back after selection
    onBack()
  }

  const onBack = () => {
    router.back()
  }

  return (
    <MarketTrendsLocationSearch
      onSelectRegion={onRegionSelect}
      onBack={onBack}
    />
  )
}
